<div
    class="bazis-dateplate"
    *transloco="let t"
>
    @if (titleKey()) {
        <span>
            {{ t(titleKey(), titleParams()) }}

            @if (count) {
                <span class="bh-text-nowrap">
                    {{ t('count.dates', { pluralType: count() | plural, count: count() }) }}
                </span>
            }

            @if (date()) {
                <span class="bh-text-nowrap">
                    {{ date() | localDate: 'longDateMonth' }}
                </span>
            }

            <br />
        </span>
    }

    @if (calculatedTime() !== null) {
        <span
            class="bazis-dateplate__time"
            [class.bazis-dateplate__time_small]="size() === 'mini'"
        >
            @if (!hideTime()) {
                <bazis-icon
                    [size]="size()"
                    name="clock"
                    class="bazis-text_secondary"
                ></bazis-icon>
            }

            @if (calculatedTime()) {
                <span>
                    {{ calculatedTime() }}
                </span>
            }

            @if (calculatedTimeStart()) {
                <span>
                    {{ calculatedTimeStart() }}
                    {{ calculatedTimeEnd() ? ' &ndash; ' + calculatedTimeEnd() : '' }}
                </span>
            }

            @if (
                !calculatedTimeStart() && !calculatedTimeEnd() && !calculatedTime() && !hideTime()
            ) {
                <span>
                    {{ t('title.noTime') }}
                </span>
            }
        </span>
    }
</div>
